import { PriceType } from 'common/api/autogenerated/trading-gateway';

import { SpotInvokeEnum, SpotSocketConfigType } from './types';
import { sharedID } from 'blocks/SocketProvider/constants';

const baseConfig = (invokeType: SpotInvokeEnum, symbol: string, priceType: PriceType): SpotSocketConfigType => ({
  hub: 'hubs/shared',
  invokeType,
  subscribeId: sharedID,
  data: [[symbol], priceType],
  id: `${symbol}:${priceType}`,
  hubEvents: [],
});

export const subscribeConfig = (symbol: string, priceType: PriceType): SpotSocketConfigType => ({
  ...baseConfig(SpotInvokeEnum.SUBSCRIBE, symbol, priceType),
  hubEvents: [SpotInvokeEnum.RECEIVE_BESTASK, SpotInvokeEnum.RECEIVE_BESTBID, SpotInvokeEnum.RECEIVE_LASTPRICE],
});

export const unsubscribeConfig = (symbol: string, priceType: PriceType): SpotSocketConfigType => ({
  ...baseConfig(SpotInvokeEnum.UNSUBSCRIBE, symbol, priceType),
});

export default { subscribeConfig, unsubscribeConfig };
